import axios from 'axios'
import store from '@/store/index'
import router from '@/router/index'
import deepCopy from 'json-deep-copy'
import { isEmptyObject } from '@/assets/js/util'

axios.interceptors.request.use(
  config => {
    if (store.state.token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.token = store.state.token
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

axios.interceptors.response.use(
  response => {
    if (response.data.data && response.data.data.isLogin === false) {
      // tips('登録に失敗しました、再度登録してください')
      store.dispatch('setToken', '')
    }
    if (response.data.code === -10) {
      tips('当前版本过老，请更新')
      return
    }
    if (response.data.code === -11) {
      tips(response.data.msg)
      return
    }
    if (response.data.code === -3) {
      // tips(response.data.msg)
      store.dispatch('setToken', '')
      router.push('/login')
    }
    if (response.data.code === -8) {
      // tips(response.data.msg)
      store.dispatch('setToken', '')
      router.push('/login')
    }
    if (response.data.success === false) {
      if (response.data.msg !== '超时' && response.data.msg !== 'タイムアウト') {
        tips(response.data.msg, 1500, 'error')
      }
    }
    if (response.data.data && response.data.data.changeData) {
      const data = response.data.data.changeData
      let msg = ''
      if (data.newGradeId) {
        msg = `レベルが${data.newGradeName}にアップしました`
        gradeUpTips(msg)
      } else {
        const user = deepCopy(store.state.user)
        if (data.exp) {
          msg = `${data.expDesc},経験値${data.exp > 0 ? '+' + data.exp : data.exp}`
        }
        if (!isEmptyObject(user)) {
          if (data.point) {
            user.memberWealth.point += data.point
            msg += `<br />${data.pointDesc}、ポイント${data.point > 0 ? '+' + data.point : data.point}`
          }
          if (data.money) {
            user.memberWealth.money += data.money
            msg += `<br />${data.moneyDesc},金钱${data.money > 0 ? '+' + data.money : data.money}`
          }
        }
        msg = msg.replace(/(^\s*)/g, '')
        store.commit('SET_USER', user)
        tips(msg, 1500, 'right')
      }
      response.data.msg = ''
    }
    return response
  },
  error => {
    if (error.data && error.data.msg) {
      tips(error.data.msg, 2500, 'error')
    } else {
      // tips('タイムアウト')
    }
    return error
  }
)

function gradeUpTips (str) {
  let contain = document.createElement('div')
  contain.setAttribute('class', 'shadow_nr')
  let tips = document.createElement('div')
  tips.setAttribute('class', 'shadow-gradeup-cont')
  let imgContent = document.createElement('div')
  let buttonContent = document.createElement('div')
  buttonContent.innerHTML = `<button style="background: transparent; width:90px; height: 40px; border: 2px solid white; color: white;border-radius:20px;" onclick="document.body.removeChild(this.parentNode.parentNode.parentNode)">分かりました</button>` +
    `<button style="background: transparent; width:90px; height: 40px; border: 2px solid white; color: white;border-radius:20px; margin-left: 50px;" onclick="window.location.href='/#/index/member/grade';document.body.removeChild(this.parentNode.parentNode.parentNode)">レベル区分</button>`
  imgContent.innerHTML = `<img src="./static/images/levelup.png" style="width:70%; height:70%"><p style="color: white; font-size: 28px; margin-bottom: 20px;">${str}</p>`
  tips.append(imgContent)
  tips.append(buttonContent)
  contain.append(tips)
  document.body.append(contain)
}

function tips (str, interval, icon) {
  if (!interval) {
    interval = 1000
  }
  const lastTips = document.getElementsByClassName('tips-contain')
  if (lastTips.length > 0) {
    setTimeout(() => {
      tips(str, interval, icon)
    }, 500)
    return false
  }
  let contain = document.createElement('div')
  contain.setAttribute('class', 'tips-contain')
  let tipDiv = document.createElement('div')
  tipDiv.setAttribute('class', 'tips')
  let body = document.createElement('div')
  body.setAttribute('class', 'tips-body')
  let rightIcon = document.createElement('p')
  rightIcon.innerHTML = '<img src="./static/images/rightTip.png" style="height:40px; height:40px;">'
  let errorIcon = document.createElement('p')
  errorIcon.innerHTML = '<img src="./static/images/errorTip.png" style="height:40px; height:40px;">'
  let p = document.createElement('p')
  p.innerHTML = str
  if (icon === 'right') {
    body.append(rightIcon)
  }
  if (icon === 'error') {
    body.append(errorIcon)
  }
  body.append(p)
  tipDiv.append(body)
  contain.append(tipDiv)
  document.body.append(contain)
  setTimeout(() => {
    if (contain.parentNode) {
      document.body.removeChild(contain)
    }
  }, interval)
}



// WEBPACK FOOTER //
// ./src/assets/js/axiosInterceptors.js